import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GeoJSON, withLeaflet } from 'react-leaflet';

class Overlay extends PureComponent {
  static propTypes = {
    fill: PropTypes.bool,
    fillColor: PropTypes.string,
    weight: PropTypes.number,
    color: PropTypes.string,
    opacity: PropTypes.number,
    data: PropTypes.array,
    smoothFactor: PropTypes.number,
  };

  static defaultProps = {
    fill: false,
    fillColor: '#eee',
    weight: 1,
    color: '#777',
    opacity: 1,
    fillOpacity: 0.5,
    data: null,
    smoothFactor: 0.5,
  };

  render() {
    if (!this.props.data) {
      return null;
    }

    return (
      <GeoJSON
        data={this.props.data}
        fill={this.props.fill}
        fillColor={this.props.fillColor}
        weight={this.props.weight}
        color={this.props.color}
        opacity={this.props.opacity}
        fillOpacity={this.props.fillOpacity}
        smoothFactor={this.props.smoothFactor}
        className={this.props.className}
      />
    );
  }
}

const OverlayWithLeaflet = withLeaflet(Overlay);

export default OverlayWithLeaflet;
